<section class="container">
  <div class="row centered gutters">
    <div class="col-md-8">
      <h1 class="header">Uh-oh!</h1>
      <p class="body">
        It appears that you've tried to find something that doesn't exist. If
        you believe this message is in error,
        <a
          href="mailto:help@creallc.com?subject=Error accessing {{
            getCurrentLocation()
          }}&body=I tried to access this page and got an error."
          >submit a ticket</a
        >
        to the helpdesk. Otherwise go <a href="/">home</a>.
      </p>
    </div>
  </div>
</section>
